import React from 'react';

import { Auth } from 'aws-amplify';
import { Col, Form, Label, Row } from 'reactstrap';

import Inputs from '../Common/Inputs/Inputs';
import FlashMessages from '../Common/Messages/FlashMessages';
import { Button, ModalContainer } from '../Common';
import Constants from '../../Constants';
import PasswordStrength from './PasswordStrength';
import './ChangePassword.scss';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

const getDefaultState = () => ({
  newPassword: '',
  currentPassword: '',
  lowercase: false,
  uppercase: false,
  number: false,
  specialChar: false,
  characterLength: false,
  failedLabels: [],
  errorMessage: null,
  notTouched: true,
  dirty: false,
  passwordChanged: false,
});

class ChangePassword extends React.Component {
  state = getDefaultState();

  constructor(props) {
    super(props);
    this.refCurrentPasswordInput = React.createRef();
    this.refNewPasswordInput = React.createRef();
  }

  submitChangedPass = ({ setOpened }) => {
    const { currentPassword, newPassword, failedLabels } = this.state;
    this.setState({
      errorMessage: null,
      dirty: true,
      notTouched: false,
    });
    if (newPassword && currentPassword && failedLabels.length === 0) {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(user, currentPassword, newPassword);
        })
        .then(() => {
          this.setState({ passwordChanged: true });
          setOpened(false);
        })
        .catch((err) => {
          this.setState({ errorMessage: 'Incorrect current password' });
        });
    } else {
      newPassword ? void 0 : this.refNewPasswordInput.current.focus();
      currentPassword ? void 0 : this.refCurrentPasswordInput.current.focus();
    }
  };

  handleInputCurrentPassword = (currentPassword) => {
    this.setState({
      currentPassword,
    });
  };

  onChangeNewPassword = (newPassword) => {
    this.setState({
      newPassword,
      notTouched: false,
      dirty: true,
    });
  };

  hideFlashMessage = () => {
    this.setState({ errorMessage: null });
  };

  renderModalBody() {
    const { errorMessage } = this.state;
    const controlSize = layoutGridSize - formLabelSize;
    const controlSizeSm = layoutGridSize - formLabelSizeSm;
    return (
      <React.Fragment>
        <FlashMessages
          close={this.hideFlashMessage}
          type="error"
          msg={errorMessage}
          open={!!errorMessage}
          classNames="change-pass"
          scope="ModalChangePassword"
        />
        <Form className="modal-form margin-center">
          <input autoComplete="username" id="username" style={{ display: 'none' }} type="text" name="username" />
          <Inputs
            autoComplete="off"
            onInputChange={(e, value) => this.handleInputCurrentPassword(value)}
            errorMessages={this.state.dirty && !this.state.currentPassword}
            required="required"
            title="Current Password"
            name="currentPassword"
            id="currentPassword"
            type="password"
            placeholder="Current password"
            value={this.state.currentPassword}
            refInput={this.refCurrentPasswordInput}
          />
          <Row className="v-middle-align">
            <Label for="newPassword" className="ScalaSansOT text-left" sm={formLabelSizeSm} md={formLabelSize}>
              New Password
            </Label>
            <Col className="input-left" sm={controlSizeSm} md={controlSize}>
              <input
                ref={this.refNewPasswordInput}
                tabIndex={0}
                aria-describedby={`passwordRequirementsList_${btoa(this.state.newPassword.replace(/\s/g, ''))}_id`}
                autoComplete="new-password"
                aria-invalid={this.state.dirty && this.state.failedLabels.length > 0}
                type="password"
                value={this.state.newPassword}
                name="newPassword"
                id="newPassword"
                data-testid="newPassword"
                placeholder="New password"
                required
                className={['input', this.state.dirty && this.state.failedLabels.length > 0 ? 'border-error' : null]
                  .filter((v) => !!v)
                  .join(' ')}
                onChange={(evt) => this.onChangeNewPassword(evt.target.value)}
              />
            </Col>
          </Row>
          <div className="mBottom-15"></div>
          <PasswordStrength
            newPassword={this.state.newPassword}
            dirty={this.state.dirty}
            onState={(state) => {
              this.setState({
                failedLabels: state.failedLabels,
              });
            }}
          />
        </Form>
      </React.Fragment>
    );
  }

  renderToggleButton = (opened, setOpened) => {
    return (
      <React.Fragment>
        <Button
          isNew
          disabled={this.props.disabled}
          onClick={() => setOpened(true)}
          appearance="secondary"
          size="small"
          text="Change Password"
          id="button-open-password-change-modal"
        />
        <span
          role={'alert'}
          id={'passwordMsgStatus'}
          className={'right-tick fontSm-18 ' + (this.state.passwordChanged ? 'visibleCust' : 'hiddenCust')}>
          <i className="far fa-check-circle"></i> Password Changed
        </span>
      </React.Fragment>
    );
  };

  render() {
    return (
      <ModalContainer
        role="dialog"
        showCloseIcon
        asToggleButtonFn={this.renderToggleButton}
        title="Change Password"
        className="change-password"
        text={this.renderModalBody()}
        onOpened={() => {
          this.setState(getDefaultState());
        }}
        buttons={[
          {
            label: 'Change',
            onClick: this.submitChangedPass,
          },
        ]}
      />
    );
  }
}

export default ChangePassword;
